import React, { useEffect, useRef, useState } from "react";
import uploadIcon from "../../../assets/img/upload2.svg"; // Replace with the actual path
import {
  emailLimit,
  getPlainPhoneNumber,
  selectLoader,
  updateUserDetails,
  userNameLimit,
  validateEmail,
  validateForm,
  validatePhoneNumber,
} from "../../../utils/Helpers";
import { useStore } from "../../../hooks/useStore";
import appToast, { TOAST_TYPE } from "../../../utils/AppToast";
import APIServices from "../../../services/APIServices";
import { useNavigate } from "react-router-dom";
import { ProjectListStrings } from "../strings/ProjectStrings";
import PhoneNumberInput from "../../../components/PhoneInput";
import { useAuth } from "contexts/AuthContext";

const UpdateProfileModal = ({
  show,
  profileUrl,
  formValues,
  setError,
  isVerified,
  setFormValues,
  toggleModal,
  setProfileUrl,
}) => {
    const { fetchUserInfo} = useAuth();
  const navigate = useNavigate();
  const [store, setStore] = useStore();
  const [loading, setLoading] = useState(false);
  const [draftValues, setDraftValues] = useState(() => ({ ...formValues }));
  const [draftProfileUrl, setDraftProfileUrl] = useState(
    profileUrl || (typeof formValues?.profilePic === "string" ? formValues.profilePic : "")
  );
  const previewObjectUrlRef = useRef(null);
  const [verifing, setVerifing] = useState({
    email: false,
    phoneNumber: false,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (show) {
      if (previewObjectUrlRef.current) {
        URL.revokeObjectURL(previewObjectUrlRef.current);
        previewObjectUrlRef.current = null;
      }
      setDraftValues({ ...formValues });
      setDraftProfileUrl(
        profileUrl || (typeof formValues?.profilePic === "string" ? formValues.profilePic : "")
      );
      setErrors({});
    } else if (previewObjectUrlRef.current) {
      URL.revokeObjectURL(previewObjectUrlRef.current);
      previewObjectUrlRef.current = null;
    }
  }, [show, formValues, profileUrl]);

  useEffect(() => {
    return () => {
      if (previewObjectUrlRef.current) {
        URL.revokeObjectURL(previewObjectUrlRef.current);
      }
    };
  }, []);

  const clearError = (name) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleVerify = async (name) => {
    const plainNumber = getPlainPhoneNumber(draftValues.phoneNumber);
    const url = "/send-verification-code";
    const isEmail = name === "email";
    setVerifing({
      // email: isEmail && true,
      phoneNumber: true,
    });
    let isValid = false;
    let payload = {};

    const updateErrors = (field, message) => {
      setErrors({
        ...errors,
        [field]: message,
      });
    };

    const handleResponse = (response) => {
      if (response.message) {
        setStore({
          countryDialCode: draftValues.countryDialCode,
          phoneNumber: plainNumber,
          userEmail: draftValues.email,
          verificationType: name,
        });
        appToast(response.message, TOAST_TYPE.SUCCESS);
        navigate("/verification", {
          state: { isEmail, diableFields: false },
        });
      }
    };

    if (isEmail) {
      const email = draftValues.email;
      isValid = validateEmail(email);
      if (!isValid) {
        updateErrors("email", "Please enter a valid email address.");
        return;
      }
      payload = { email };
    } else {
      isValid = validatePhoneNumber(plainNumber);
      if (!isValid) {
        updateErrors("phoneNumber", "PhoneNumber should be 10-15 digits long.");
        return;
      }
      payload = {
        phoneNumber: plainNumber,
        countryDialCode: draftValues.countryDialCode,
      };
    }
    try {
      const response = await APIServices.post(url, payload);
      handleResponse(response);
    } catch (err) {
      console.error("Error while Updating profile:", err);
    } finally {
      setVerifing({
        email: false,
        phoneNumber: false,
      });
    }
  };

  const validate = () => {
    let tempErrors = validateForm(draftValues);
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handlePhoneChange = (val, countryDialCode) => {
    setDraftValues((prevValues) => ({
      ...prevValues,
      phoneNumber: val,
      countryDialCode: `${countryDialCode}`,
    }));

    clearError("phoneNumber"); // Clear error for phone field
  };
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setDraftValues((prevValues) => ({
      ...prevValues,
      [name]: type === "checkbox" ? checked : value,
    }));

    clearError(name); // Clear error for the current field
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }

    if (previewObjectUrlRef.current) {
      URL.revokeObjectURL(previewObjectUrlRef.current);
    }

    const nextPreviewUrl = URL.createObjectURL(file);
    previewObjectUrlRef.current = nextPreviewUrl;
    setDraftProfileUrl(nextPreviewUrl);
    setDraftValues((prevValues) => ({
      ...prevValues,
      profilePic: file,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      let plainNumber = getPlainPhoneNumber(draftValues.phoneNumber);
      const updatedFormValues = {
        ...draftValues,
        phoneNumber: plainNumber,
      };
      let isUpdated = await updateUserDetails(
        updatedFormValues,
        setError,
        setLoading,
        undefined,
        undefined
      );
      if (isUpdated) {
        const savedProfileUrl = isUpdated?.user?.profilePic || profileUrl;
        setProfileUrl(savedProfileUrl);
        setFormValues({
          ...draftValues,
          profilePic: savedProfileUrl
        });
        fetchUserInfo();
        toggleModal("updateProfile", false);
      }
    }
  };

  return (
    <>
      <div className="usee-deatils">
        {(draftProfileUrl || draftValues?.profilePic) && (
          <img
            src={draftProfileUrl || draftValues?.profilePic}
            alt={ProjectListStrings.userImageAlt}
            className="user-pic"
          />
        )}
        <input
          accept="image/*"
          type="file"
          id="myFile"
          name="filename"
          onChange={handleFileChange}
        />
        <img
          src={uploadIcon}
          alt={ProjectListStrings.uploadIconAlt}
          className="user-upload"
        />
      </div>
      <div className="profile-deatils">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-12">
              <div className="input-group mb-3">
                <input
                  maxLength={userNameLimit}
                  type="text"
                  className={`form-control ${
                    errors.fullName ? "form-invalid" : ""
                  }`}
                  placeholder={ProjectListStrings.fullNamePlaceholder}
                  name="fullName"
                  value={draftValues.fullName}
                  onChange={handleChange}
                />
                {errors.fullName && (
                  <span className="error-message">{errors.fullName}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="input-group mb-3">
                <input
                  maxLength={emailLimit}
                  disabled={false}
                  type="text"
                  className={`form-control ${
                    errors.email ? "form-invalid" : ""
                  }`}
                  name="email"
                  placeholder={ProjectListStrings.emailPlaceholder}
                  value={draftValues.email}
                  onChange={handleChange}
                />
                {!isVerified.isEmailVerified && (
                  <p
                    className="veryfy-text"
                    onClick={() => {
                      handleVerify("email");
                    }}
                  >
                    {verifing.email
                      ? <div className="d-flex justify-content-end">{selectLoader(20)}</div>
                      : ProjectListStrings.phoneNumberVerifyText}
                  </p>
                )}
                {errors.email && (
                  <span className="error-message">{errors.email}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="input-group mb-3 phone-number-group">
                <div className="phone-number-group-cover mb-10">
                  <PhoneNumberInput
                    isDisable={false}
                    value={draftValues.phoneNumber}
                    onPhoneChange={(val) =>
                      handlePhoneChange(val, draftValues.countryDialCode)
                    }
                    countryDialCode={draftValues.countryDialCode}
                    countryName={draftValues.countryCode}
                    onCountryChange={(country) => {
                      setDraftValues((prevValues) => ({
                        ...prevValues,
                        countryDialCode: country.dialCode,
                        countryCode: country.value,
                      }));
                      handlePhoneChange(
                        draftValues.phoneNumber,
                        country.dialCode
                      );
                    }}
                    errors={errors.phoneNumber}
                  />
                  <div className="d-flex w-100">
                    {errors.phoneNumber && (
                      <span className="error-message">
                        {errors.phoneNumber}
                      </span>
                    )}
                    {!isVerified.isPhoneNumberVerified && (
                      <p
                        className="veryfy-text"
                        onClick={() => {
                          handleVerify("phone");
                        }}
                      >
                        {verifing.phoneNumber
                          ? <div className="d-flex justify-content-end">{selectLoader(20)}</div>
                          : ProjectListStrings.phoneNumberVerifyText}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button
            onClick={(e) => {
              handleSubmit(e);
            }}
            type="button"
            className="btn-black"
          >
            {!loading ? ProjectListStrings.saveButtonText : selectLoader(35)}
          </button>
        </form>
      </div>
    </>
  );
};

export default UpdateProfileModal;
